import http from "./httpService";
import { EpidemicTypes } from "../pages/epidemic";
import { getJwt } from "./authService";
const apiEndpoint = process.env.REACT_APP_API_URL + "/epidemics";

http.setJwt(getJwt()!);

export const postEpidemic = async (params: EpidemicTypes) => {
  const { data } = await http.post(apiEndpoint, { ...params });

  return data;
};

export const updateEpidemic = async (params: any, id: string) => {
  delete params._id;
  delete params.__v;

  const { data } = await http.put(apiEndpoint + `/${id}`, { ...params });
  return data;
};

export default postEpidemic;
